export const ACCOUNT = 'account';
export const AUTH = 'auth';
export const COLOURS = 'colours';
export const DASHBOARDS = 'dashboards';
export const MONITORS = 'monitors';
export const FILTERS = 'filters';
export const KPIS = 'kpis';
export const INTEGRATIONS = 'integrations';
export const ROLE = 'role';
export const PERSISTENCE = 'persistence';
export const SETTINGS = 'settings';
export const UI = 'ui';
export const USERS = 'users';
export const WIDGETS = 'widgets';
